module.exports = __webpack_public_path__ + "static/img/13g.01fb2c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/13g.jpg
// module id = lcHO
// module chunks = 0